// Types
import { PageRule } from '@/types/routing/routing';

// Constants
import {
  HomeDataTypeName,
  LandingDataTypeName,
  ArticleDataTypeName,
  ProductDetailsDataTypeName,
  LocalisationPatternMatcher,
} from '@/constants/configuration';

export const rules: PageRule[] = [
  {
    type: 'home',
    bodyDataType: HomeDataTypeName,
    pattern: `^${LocalisationPatternMatcher}/$`,
  },
  {
    type: 'article',
    bodyDataType: ArticleDataTypeName,
    pattern: `^${LocalisationPatternMatcher}/article/`,
  },
  {
    type: 'article_about',
    bodyDataType: ArticleDataTypeName,
    pattern: `^${LocalisationPatternMatcher}/about/`,
  },
  {
    type: 'article_about_stis',
    bodyDataType: ArticleDataTypeName,
    pattern: `^${LocalisationPatternMatcher}/about-stis/`,
  },
  {
    type: 'article_contraception',
    bodyDataType: ArticleDataTypeName,
    pattern: `^${LocalisationPatternMatcher}/contraception/`,
  },
  {
    type: 'article_self_sampling',
    bodyDataType: ArticleDataTypeName,
    pattern: `^${LocalisationPatternMatcher}/self-sampling/`,
  },
  {
    type: 'sti_test_kits',
    bodyDataType: ProductDetailsDataTypeName,
    pattern: `^${LocalisationPatternMatcher}/sti-test-kits/`,
  },
  {
    type: 'referrer',
    bodyDataType: LandingDataTypeName,
    pattern: `^${LocalisationPatternMatcher}/partner/`,
  },
  {
    type: 'university_landing',
    bodyDataType: LandingDataTypeName,
    pattern: `^${LocalisationPatternMatcher}/university/`,
  },
  {
    type: 'sexual_health',
    bodyDataType: LandingDataTypeName,
    pattern: `^${LocalisationPatternMatcher}/sexual-health/`,
  },
];
